//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

$(document).ready(function(){
  //Half Half Slideshows
  const halfHalfSwiper = new Swiper('.half_half_slideshow .swiper-container', {
    speed: 1000,
    effect: 'fade',
    touch: false,
    autoplay: {
     delay: 5000,
    }
  });

  //Full Slideshows
  const fullSwiper = new Swiper('.full_slideshow .swiper-container', {
    speed: 600,
    loop: true,
    effect: 'fade',
    navigation: {
      nextEl: '.next',
      prevEl: '.prev'
    }
  });

  //Gallery Slideshows
  const gallerySwiper = new Swiper('.gallery .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    }
  });

  //iPhone Slideshows
  const iPhoneSwiper = new Swiper('#iphone_gallery .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    },
    autoplay: {
      delay: 3000
    }
  });

  //Product Mob Slideshows
  /*const productSwiper = new Swiper('.product_images_mob .swiper-container', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });*/

  //Clients Marquee
  Marquee3k.init();

  //Shop Submenus Mobile
  if ( Modernizr.touchevents ) {
    $('a.toggle-submenu').click(function(e){
      e.preventDefault();
      $(this).parents('li.has-submenu').toggleClass('open');
    })
  }

  //Product Tabs
  $('.product_tab .title').click(function(){
    $(this).parents('.product_tab').toggleClass('open');
    $(document.body).trigger("sticky_kit:recalc");
  });

  //Product Alt Sticky
  $(".sticky-kit").stick_in_parent({
    offset_top: 128,
    recalc_every: 1,
  });

  //Toggle Mob Menu
  $('.toggle_menu').click(function(e){
    e.preventDefault();
    $('#mob_menu').toggleClass('open');
  });
});